import styled from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledPopupFooterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  position: fixed;
  z-index: 2;
  bottom: 0;
  padding: ${toRem(16)} ${toRem(24)} ${toRem(24)};
  width: 100%;
  background-color: ${theme.color.white};
  border-top: ${toRem(1)} solid ${theme.color['light-gray-3']};

  .reset-btn {
    text-align: center;
    padding: 0;
    margin-top: ${toRem(11)};
    background: transparent;
  }

  @media ${theme.mediaQuery.tablet} {
    display: none;
  }
`;
